(() => {
  const root = document.querySelector('[data-lcx]');
  if (!root) return;
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  const product = JSON.parse($('[data-lcx-json]').textContent);
  const idInput = $('[data-lcx-variant]');
  const addBtn = $('[data-lcx-add]');
  const stickyBtn = $('[data-lcx-sticky-add]');
  const errorEl = $('[data-lcx-error]');
  const groups = $$('[data-lcx-option]');
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const money = c => { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } };
  const lcCase = s => /[a-z]/.test(s) ? s : s.charAt(0) + s.slice(1).toLowerCase();
  const params = new URL(location.href).searchParams;
  let variant = product.variants.find(v => String(v.id) === params.get('variant')) || product.variants.find(v => String(v.id) === idInput.value) || product.variants[0];

  /* ---------- Gallery ---------- */
  const allThumbs = $$('[data-lcx-thumb]');
  let thumbs = allThumbs.slice();
  const mainImg = root.querySelector('#lcx-main-image');
  const countEl = $('[data-lcx-count]'), capEl = $('[data-lcx-caption]');
  const thumbWrap = $('.thumbs');
  const optNames = (product.options || []).map(o => String(typeof o === 'string' ? o : o.name).toLowerCase());
  const colorIdx = optNames.findIndex(n => /colou?r|style|pattern|finish|shade|print/.test(n));
  const altKey = t => (t.dataset.alt || '').toLowerCase().trim();
  const optVals = i => [...new Set(product.variants.map(v => String(v.options[i]).toLowerCase().trim()))];
  const matchVal = (t, vals) => vals.find(c => altKey(t) === c || altKey(t).startsWith(c + ' ') || altKey(t).endsWith(' ' + c));
  /* Photos are tagged to an option value through their alt text (a colour, or a size such as 74 x 30" x 5"); prefer the colour option */
  const isTagged = i => i >= 0 && allThumbs.some(t => matchVal(t, optVals(i)));
  const tagIdx = isTagged(colorIdx) ? colorIdx : optNames.findIndex((n, i) => isTagged(i));
  const colorVals = tagIdx >= 0 ? optVals(tagIdx) : [];
  const taggedFor = t => matchVal(t, colorVals);
  /* Images assigned to variants (for example one graphic per size): show only the selected variant's own image so near-identical graphics do not repeat */
  const variantMediaIds = new Set(product.variants.map(v => v.featured_media && String(v.featured_media.id)).filter(Boolean));
  const isVariantImage = t => variantMediaIds.has(String(t.dataset.mediaId));
  function filterGallery(v) {
    if (!v) return false;
    let next = null;
    if (tagIdx >= 0) {
      const val = String(v.options[tagIdx]).toLowerCase().trim();
      if (allThumbs.some(t => taggedFor(t) === val)) next = allThumbs.filter(t => { const tag = taggedFor(t); return !tag || tag === val; });
    }
    if (!next && variantMediaIds.size > 1 && allThumbs.some(t => !isVariantImage(t))) {
      const own = v.featured_media ? String(v.featured_media.id) : '';
      next = allThumbs.filter(t => !isVariantImage(t) || String(t.dataset.mediaId) === own);
    }
    if (!next) return false;
    thumbs = next;
    gi = 0;
    buildTrack();
    allThumbs.forEach(t => { t.hidden = !thumbs.includes(t); });
    if (thumbWrap) { thumbWrap.style.setProperty('--tcols', Math.min(Math.max(thumbWrap.querySelectorAll('.thumb:not([hidden])').length, 1), 8)); thumbWrap.scrollLeft = 0; }
    requestAnimationFrame(updateArrows);
    return true;
  }
  let gi = Math.max(0, thumbs.findIndex(t => t.classList.contains('active')));
  function selectGallery(i, fromTrack) {
    if (!thumbs.length) return;
    gi = (i + thumbs.length) % thumbs.length;
    const t = thumbs[gi];
    if (track && !fromTrack) { track.scrollTo({ left: gi * track.clientWidth, behavior: track.dataset.fresh ? 'auto' : 'smooth' }); delete track.dataset.fresh; }
    if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.full; mainImg.alt = t.dataset.alt; }
    allThumbs.forEach(x => { const on = x === t; x.classList.toggle('active', on); x.setAttribute('aria-pressed', String(on)); });
    if (countEl) countEl.textContent = (gi + 1) + ' / ' + thumbs.length;
    if (capEl) capEl.textContent = 'Lincove product photography' + (t.dataset.alt ? ' · ' + t.dataset.alt : '');
    const strip = t.parentElement;
    if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2), behavior: 'smooth' });
  }
  allThumbs.forEach(t => t.addEventListener('click', () => selectGallery(thumbs.indexOf(t))));
  $('[data-lcx-prev]')?.addEventListener('click', () => selectGallery(gi - 1));
  $('[data-lcx-next]')?.addEventListener('click', () => selectGallery(gi + 1));
  /* Mobile: a strip of photographs that follows the finger and snaps to each photograph */
  const frame = $('.mainframe');
  const mobile = window.matchMedia('(max-width: 700px), (pointer: coarse)');
  let track = null;
  function buildTrack() {
    if (!frame) return;
    if (track) { track.remove(); track = null; }
    frame.classList.toggle('lcx-has-track', mobile.matches);
    if (!mobile.matches || !thumbs.length) return;
    track = document.createElement('div');
    track.className = 'lcx-track';
    thumbs.forEach((t, i) => {
      const img = document.createElement('img');
      img.src = t.dataset.full.replace(/width=\d+/, 'width=900');
      img.alt = t.dataset.alt || '';
      img.loading = Math.abs(i - gi) < 2 ? 'eager' : 'lazy';
      img.decoding = 'async';
      track.appendChild(img);
    });
    frame.insertBefore(track, frame.firstChild);
    track.dataset.fresh = '1';
    track.scrollLeft = gi * track.clientWidth;
    let settle;
    track.addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== gi) selectGallery(i, true);
      }, 90);
    }, { passive: true });
  }
  mobile.addEventListener?.('change', buildTrack);
  const tPrev = $('[data-lcx-tprev]'), tNext = $('[data-lcx-tnext]');
  function updateArrows() {
    if (!thumbWrap || !tPrev || !tNext) return;
    const max = thumbWrap.scrollWidth - thumbWrap.clientWidth;
    const img = thumbWrap.querySelector('.thumb:not([hidden]) img');
    if (img) { const top = img.offsetTop + img.offsetHeight / 2 + 'px'; tPrev.style.top = top; tNext.style.top = top; }
    tPrev.hidden = !(max > 2 && thumbWrap.scrollLeft > 2);
    tNext.hidden = !(max > 2 && thumbWrap.scrollLeft < max - 2);
  }
  function pageThumbs(dir) { if (thumbWrap) thumbWrap.scrollBy({ left: dir * thumbWrap.clientWidth * 0.85, behavior: 'smooth' }); }
  tPrev?.addEventListener('click', () => pageThumbs(-1));
  tNext?.addEventListener('click', () => pageThumbs(1));
  thumbWrap?.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  window.addEventListener('load', updateArrows);
  updateArrows();
  if (thumbs.length) { countEl && (countEl.textContent = (gi + 1) + ' / ' + thumbs.length); }

  /* ---------- Modal ---------- */
  const modal = $('[data-lcx-modal]');
  function showModal(title, html) {
    $('[data-lcx-modal-title]').textContent = title;
    $('[data-lcx-modal-body]').innerHTML = html;
    modal.showModal();
  }
  $('[data-lcx-modal-close]').addEventListener('click', () => modal.close());
  modal.addEventListener('click', e => { if (e.target === modal) modal.close(); });
  modal.addEventListener('close', () => modal.querySelectorAll('video').forEach(v => v.pause()));
  $('[data-lcx-zoom]')?.addEventListener('click', () => {
    const t = thumbs[gi];
    const src = t ? t.dataset.full.replace(/width=\d+/, 'width=2000') : mainImg.src;
    showModal(product.title, '<img src="' + src + '" alt="' + (mainImg.alt || '').replace(/"/g, '&quot;') + '"><p class="small">Lincove product photography</p>');
  });
  $('[data-lcx-size]')?.addEventListener('click', () => { const t = $('[data-lcx-size-template]'); if (t) showModal('Size & fit', t.innerHTML); });
  $('[data-lcx-film]')?.addEventListener('click', () => { const t = $('[data-lcx-film-template]'); if (t) showModal(product.title, t.innerHTML); });
  $$('[data-lcx-video]').forEach(b => b.addEventListener('click', () => showModal('Customer video', '<video controls playsinline autoplay src="' + b.dataset.lcxVideo + '" poster="' + (b.dataset.poster || '') + '"></video><p class="small">Customer video, shared with permission.</p>')));

  /* ---------- Variants ---------- */
  const selected = () => groups.map(g => g.querySelector('[aria-pressed="true"]')?.dataset.value);
  function pairSaving() {
    const el = $('[data-lcx-pair-saving]'); if (!el) return;
    const gIndex = groups.findIndex(g => g.classList.contains('pack-choices'));
    if (gIndex < 0) return;
    const sel = selected();
    const find = n => product.variants.find(v => v.options.every((o, i) => i === gIndex ? /\d/.test(o) && o.match(/\d+/)[0] === String(n) : o === sel[i]));
    const one = find(1), two = find(2);
    el.textContent = (one && two) ? 'Save 10%' : '';
  }
  function render(v, push) {
    variant = v;
    const label = v && v.available ? 'Add to bag · ' + money(v.price) : (v ? 'Sold out' : 'Unavailable');
    addBtn.textContent = label; addBtn.disabled = !(v && v.available);
    if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = addBtn.disabled; }
    if (!v) return;
    idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true }));
    $('[data-lcx-price]').textContent = money(v.price);
    $('[data-lcx-compare]').textContent = v.price > 0 ? money(Math.floor(v.price * 4 / 3)) : '';
    $('[data-lcx-deal]').textContent = '';
    const sc = $('[data-lcx-sticky-choice]'); if (sc) sc.textContent = v.options.map(o => lcCase(String(o))).join(' · ') + ' · ' + money(v.price);
    groups.forEach((g, i) => g.querySelectorAll('button').forEach(b => {
      const on = b.dataset.value === v.options[i]; b.classList.toggle('active', on); b.setAttribute('aria-pressed', String(on));
    }));
    const filtered = filterGallery(v);
    let k = -1;
    if (v.featured_media) k = thumbs.findIndex(t => String(t.dataset.mediaId) === String(v.featured_media.id));
    if (k < 0 && filtered) k = 0;
    if (k < 0) {
      const names = (product.options || []).map(o => String(typeof o === 'string' ? o : o.name).toLowerCase());
      const idx = names.findIndex(n => /colou?r|style|pattern|finish|shade/.test(n));
      if (idx >= 0) {
        const val = String(v.options[idx]).toLowerCase().trim();
        const slug = val.replace(/[^a-z0-9]+/g, '-');
        k = thumbs.findIndex(t => (t.dataset.alt || '').toLowerCase().includes(val) || (t.dataset.full || '').toLowerCase().includes(slug));
      }
    }
    if (k >= 0 && (k !== gi || filtered)) selectGallery(k);
    pairSaving();
    if (push) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
  }
  groups.forEach((g, gi2) => g.addEventListener('click', e => {
    const b = e.target.closest('button[data-value]'); if (!b) return;
    const sel = selected(); sel[gi2] = b.dataset.value;
    let v = product.variants.find(x => x.options.every((o, i) => o === sel[i]));
    if (!v || !v.available) v = product.variants.find(x => x.available && x.options[gi2] === b.dataset.value) || v;
    render(v, true);
  }));

  /* ---------- Add to bag ---------- */
  async function add(btn) {
    if (!variant || !variant.available) return;
    errorEl.hidden = true;
    const items = [{ id: variant.id, quantity: 1 }];
    if (window.lcAdd) return window.lcAdd(items, btn);
    try {
      const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw Error((await r.json()).description || 'Unable to add this selection');
      location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (e) { errorEl.textContent = e.message; errorEl.hidden = false; }
  }
  $('[data-lcx-form]').addEventListener('submit', e => { e.preventDefault(); add(addBtn); });
  stickyBtn?.addEventListener('click', () => add(stickyBtn));

  /* ---------- Material tabs ---------- */
  const mText = $('[data-lcx-material-text]'), mImg = root.querySelector('[data-lcx-material-img]') || root.querySelector('.material-figure img');
  $$('[data-lcx-material]').forEach(b => b.addEventListener('click', () => {
    if (mText) mText.textContent = b.dataset.text;
    if (mImg && b.dataset.img) { mImg.removeAttribute('srcset'); mImg.src = b.dataset.img; }
    $$('[data-lcx-material]').forEach(x => { x.classList.toggle('active', x === b); x.setAttribute('aria-pressed', String(x === b)); });
  }));

  /* ---------- Guide ---------- */
  const guide = $('[data-lcx-guide]'), result = $('[data-lcx-guide-result]');
  function runGuide() {
    if (!guide || !result) return;
    const a = guide.querySelector('#lcx-g1').selectedIndex, b = guide.querySelector('#lcx-g2').selectedIndex;
    let t, p, link = '';
    if (guide.dataset.kind === 'pillow') {
      if (a === 0) { t = 'Start with Medium or Firm'; p = 'Side sleepers usually need more loft to fill the space between shoulder and ear.' + (b === 1 ? ' If you prefer a softer feel, Medium is a gentle middle ground.' : ''); }
      else if (a === 1) { t = 'Start with Medium'; p = 'Back sleepers often prefer balanced support that cradles the head without pushing it forward.'; }
      else if (a === 2) { t = 'Start with Soft'; p = 'Stomach sleepers usually prefer a lower, softer pillow that keeps the neck in a comfortable line.'; }
      else { t = 'Start with Medium'; p = 'If you change positions through the night, a balanced feel is the most adaptable place to begin.'; }
      link = '<p><a href="https://quiz.lincove.com/eaadcb">Take the full pillow quiz</a></p>';
    } else {
      const hot = b === 1;
      if (a === 1 || hot) { t = 'Consider a lighter layer'; p = 'If your room stays warm or you often feel hot, compare lighter comforter options before deciding.'; link = '<p><a href="/products/canadian-down-duvet-comforter">Compare Lightweight comforters</a></p>'; }
      else if (a === 2 || b === 2) { t = 'Think in removable layers'; p = 'An all-season comforter with a separate blanket lets you adjust your bed. Personal comfort varies.'; }
      else { t = 'This is worth considering'; p = 'An all-season layer suits a comfortable room. Confirm size and care before choosing.'; }
    }
    result.innerHTML = '<h3>' + t + '</h3><p>' + p + '</p>' + link;
  }
  guide?.querySelectorAll('select').forEach(s => s.addEventListener('change', runGuide));

  runGuide();
  render(variant, false);
  if (!track) buildTrack();
})();
